import { useEffect } from "react"

import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useNavigate } from "react-router-dom"

import UserActions from "../../Containers/User/reducer"
import Icon from "../../Icon"
import { isOnboardingFinished } from "../../Utils/onboarding/isOnboardingFinished"
import {
  createAccountStepPath,
  manageEnrollmentStepPath,
  onboardingStepPath
} from "../../Utils/utils"
import ButtonComponent from "../Button"

import "./StepTitle.less"

const { Text } = Typography

const StepTitle = ({ step, maxStep = 7, style, disabledNext, ...props }) => {
  const { t } = useTranslation()

  const { enrollmentId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const onboardingNextStep = userInfo?.next_step || 2
  const onboardingFinished = isOnboardingFinished(userInfo)
  const {
    nextCreateAccountStep,
    nextManageEnrollmentStep,
    isOneProcessorConnected,
    enrollments,
    billingDescriptors,
    maxCreateSteps = 6
  } = useSelector((state) => state.user)

  const finalMaxStep = nextCreateAccountStep && maxCreateSteps ? maxCreateSteps : maxStep
  const steps = new Array(finalMaxStep).fill("_")

  const isActiveEnrollments = enrollments.some(({ is_active }) => is_active)
  const availableMaxStep =
    nextManageEnrollmentStep || nextCreateAccountStep || onboardingNextStep - 2

  const mapAvailableStep = {
    1: true,
    2: availableMaxStep > 1,
    3: availableMaxStep > 2 && isOneProcessorConnected,
    4: availableMaxStep > 3 && isOneProcessorConnected && isActiveEnrollments,
    5:
      availableMaxStep > 4 &&
      isOneProcessorConnected &&
      isActiveEnrollments &&
      (billingDescriptors?.descriptor_data?.length || billingDescriptors?.dont_remember_descriptors)
  }

  useEffect(() => {
    if (userInfo) {
      if (onboardingFinished && userInfo?.["email_added"]) {
        if (nextCreateAccountStep) {
          dispatch(UserActions.getMaxCreateStepsRequest())
          //if(step > availableMaxStep) navigate(createAccountStepPath[nextCreateAccountStep])
        } else if (enrollmentId) {
        } else {
          // navigate('/dashboard')
        }
      } else {
        if (userInfo?.["email_added"]) {
          if (userInfo?.["is_email_verified"]) {
            //if(step > availableMaxStep) navigate(onboardingStepPath[onboardingNextStep])
          } else {
            navigate("/getting_started")
          }
        } else {
          navigate("/add-email")
        }
      }
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  const handleNavigate = (newStep) => {
    if (newStep === step || newStep > availableMaxStep || !mapAvailableStep[newStep]) return
    if (onboardingFinished) {
      if (enrollmentId) {
        navigate(manageEnrollmentStepPath(enrollmentId, isAdmin)[newStep], {
          replace: newStep < step
        })
      } else {
        navigate(createAccountStepPath[newStep], { replace: newStep < step })
      }
    } else {
      navigate(onboardingStepPath[newStep + 2], { replace: newStep < step })
    }
  }

  return (
    <Flex gap={4} className="steps-block" style={style || {}}>
      {step !== 1 && (
        <ButtonComponent
          type="text"
          icon={<Icon type="chevron_left_small" />}
          className="flex center"
          style={{ width: 32 }}
          onClick={() => handleNavigate(step - 1)}
        />
      )}
      {steps.map((el, idx) => (
        <div
          key={idx}
          className={cls("steps-block-step", {
            "steps-block-step-active": idx + 1 === step,
            "steps-block-step-available_prev": idx + 1 < availableMaxStep && idx + 1 < step,
            "steps-block-step-available_next": idx + 1 <= availableMaxStep && idx + 1 > step,
            disabled: !mapAvailableStep[idx + 1]
          })}
          {...(maxStep < 7 && { style: { width: "inherit" } })}
          onClick={() => handleNavigate(idx + 1)}
        >
          <Text type="secondary" strong>
            {`${idx + 1 === step ? `${t("Step")} ` : ""}${idx + 1}`}
          </Text>
        </div>
      ))}
    </Flex>
  )
}

export default StepTitle
